import { useState } from "react";
import { Col, Typography, Space, Flex } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { Button, Card, Input } from "@rumbledirect/ui";

const { Title, Text } = Typography;

export const ClaimDossierClaimInfoTab = () => {
  const [insuranceType, setInsuranceType] = useState<string>();
  const [coverageStatus, setCoverageStatus] = useState<string>();
  const [liability, setLiability] = useState<string>();
  const [liabilityDescription, setLiabilityDescription] = useState<string>("");

  const RadioOption = ({
    label,
    subLabel,
    selected,
    onClick,
  }: {
    value: string;
    label: string;
    subLabel: string;
    selected: boolean;
    onClick: () => void;
  }) => (
    <div
      onClick={onClick}
      className={`cursor-pointer border rounded-lg p-4 text-lg transition-all flex items-start gap-4 ${
        selected ? "border-primary-600 bg-primary-900" : "border-gray-300"
      } hover:border-primary-400`}
    >
      {/* Radio rondje */}
      <div className="mt-1">
        <div
          className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
            selected ? "border-primary-600" : "border-gray-400"
          }`}
        >
          {selected && (
            <div className="w-2.5 h-2.5 bg-primary-600 rounded-full" />
          )}
        </div>
      </div>

      {/* Label en sublabel */}
      <div>
        <div className="font-medium">{label}</div>
        {subLabel && (
          <div
            className={`text-sm mt-1 ${selected ? "text-black" : "text-gray-400"}`}
          >
            {subLabel}
          </div>
        )}
      </div>
    </div>
  );

  return (
    <Flex gap={20} className="w-full !px-0">
      <Col flex="auto" className="!px-0">
        <Card title="Claim Informatie">
          <div className="mb-8">
            <Title level={4}>Verzekeringstype</Title>

            <Text className="text-gray-600 block mb-4">
              Selecteer het juiste verzekeringstype voor deze claim
            </Text>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <RadioOption
                value="intern"
                label="Intern"
                subLabel="Verzekering is afgesloten bij eigen maatschappij"
                selected={insuranceType === "intern"}
                onClick={() => setInsuranceType("intern")}
              />
              <RadioOption
                value="extern"
                label="Extern"
                subLabel="Verzekering is afgesloten bij een andere maatschappij"
                selected={insuranceType === "extern"}
                onClick={() => setInsuranceType("extern")}
              />
            </div>
          </div>

          {/* Dekking */}
          <div className="mb-8">
            <Title level={4}>Dekking</Title>
            <Text className="text-gray-600 block mb-4">
              Bepaal de dekkingsstatus voor deze claim
            </Text>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <RadioOption
                value="in_beoordeling"
                label="In beoordeling"
                subLabel="Dekking wordt onderzocht"
                selected={coverageStatus === "in_beoordeling"}
                onClick={() => setCoverageStatus("in_beoordeling")}
              />
              <RadioOption
                value="gedekt"
                label="Gedekt"
                subLabel="Volledig gedekt door polis"
                selected={coverageStatus === "gedekt"}
                onClick={() => setCoverageStatus("gedekt")}
              />
              <RadioOption
                value="voorbehoud"
                label="Voorbehoud"
                subLabel="Onder voorbehoud gedekt"
                selected={coverageStatus === "voorbehoud"}
                onClick={() => setCoverageStatus("voorbehoud")}
              />
              <RadioOption
                value="afgewezen"
                label="Afgewezen"
                subLabel="Niet gedekt door polis"
                selected={coverageStatus === "afgewezen"}
                onClick={() => setCoverageStatus("afgewezen")}
              />
            </div>
          </div>

          {/* Aansprakelijkheid */}
          <div className="mb-8">
            <Title level={4}>Aansprakelijkheid</Title>
            <Text className="text-gray-600 block mb-4">
              Bepaal wie aansprakelijk is voor de schade
            </Text>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <RadioOption
                value="eigen_schuld"
                label="Eigen schuld"
                subLabel="Verzekerde is aansprakelijk"
                selected={liability === "eigen_schuld"}
                onClick={() => setLiability("eigen_schuld")}
              />
              <RadioOption
                value="tegenpartij"
                label="Tegenpartij"
                subLabel="Tegenpartij is aansprakelijk"
                selected={liability === "tegenpartij"}
                onClick={() => setLiability("tegenpartij")}
              />
              <RadioOption
                value="anders"
                label="Anders"
                subLabel="Beschrijf de aansprakelijkheid"
                selected={liability === "anders"}
                onClick={() => setLiability("anders")}
              />
            </div>

            {liability === "anders" && (
              <div className="mt-4">
                <Input.TextArea
                  rows={4}
                  placeholder="Beschrijf de aansprakelijkheid..."
                  value={liabilityDescription}
                  onChange={(e) => setLiabilityDescription(e.target.value)}
                  className="mt-2"
                />
              </div>
            )}
          </div>
        </Card>
      </Col>

      <Col className="!px-0 2xl:min-w-[400px] min-w-[300px]">
        <Card className="w-full" title={"Acties"}>
          <Space direction="vertical" className="w-full">
            <Button
              type="primary"
              size="large"
              className="w-full"
              icon={<CheckOutlined className="!text-[17px]" />}
            >
              Claimverwerking voltooien
            </Button>
          </Space>
        </Card>
      </Col>
    </Flex>
  );
};
